module.exports = "/images/key_icon.svg?4005596371efb87acedc6c8ec6e66309";